<template>
  <a
    :href="`/projects/${endpoint.project_id}/forms/${endpoint.id}`"
    class="project-endpoint"
  >
    {{ endpoint.form_name }}
  </a>
</template>

<script>
export default {
  name: 'project-endpoint',
  props: {
    endpoint: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
.project-endpoint {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  color: $gray-800;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  border: 1px solid $gray-300;
  border-radius: $border-radius;
  transition: 0.2s;
  &:hover {
    color: $white;
    text-decoration: none;
    background-color: $primary;
    border-color: $primary;
  }
}
</style>
